module.exports = __webpack_public_path__ + "img/slaughter_house_small.0e922260.png";